import { Action } from '@ngrx/store';
import { UserSettings } from '../../../models/user-settings.model';
import { MeteringSubFilter, MeteringFilter, Widget, MeteringPoint, MeteringPointGroup } from '@model';
import { MeteringType } from '@enums';

export enum SettingActionTypes {
  SettingLoad = '[Setting] Load data',
  SettingLoadSuccess = '[Setting] Load success',
  SettingLoadFail = '[Setting] Load fail',

  SettingUpdate = '[Setting] Setting Update',
  FilterSettingUpdate = '[Setting] Filter setting Update',
  FilterSettingReset = '[Setting] Filter setting reset',
  SettingUpdateSuccess = '[Setting] Setting Update success',
  SettingUpdateFail = '[Setting] Setting Update fail',
  UserRadioSelection = '[Setting] User radio selection made',

  SetSubFilter = '[Setting] Set Metering Sub Filter',
  SubFilterReset = '[Setting] Sub Filter reset'
}

export class SettingLoad implements Action {
  readonly type = SettingActionTypes.SettingLoad;
  constructor() {}
}

export class SettingLoadSuccess implements Action {
  readonly type = SettingActionTypes.SettingLoadSuccess;
  constructor(public payload: UserSettings) {}
}

export class SettingLoadFail implements Action {
  readonly type = SettingActionTypes.SettingLoadFail;
  constructor(public payload: any) {}
}

export class SettingUpdate implements Action {
  readonly type = SettingActionTypes.SettingUpdate;
  constructor(public payload: {
    userSettings:  UserSettings,
    userId: string,
    filterArea: string,
    meteringType: MeteringType,
    meteringPoints: MeteringPoint[],
    meteringPointGroups?: MeteringPointGroup[]}) {}
}

export class SettingUpdateSuccess implements Action {
  readonly type = SettingActionTypes.SettingUpdateSuccess;
  constructor(public payload: {
    userSettings: UserSettings,
    userId: string,
    filterArea: string,
    meteringType: MeteringType,
    meteringPoints: MeteringPoint[],
    meteringPointGroups?: MeteringPointGroup[]}
    ) {}
}

export class SettingUpdateFail implements Action {
  readonly type = SettingActionTypes.SettingUpdateFail;
  constructor(public payload: any) {}
}

export class FilterSettingUpdate implements Action {
  readonly type = SettingActionTypes.FilterSettingUpdate;
  constructor(public payload: {
    meteringType: MeteringType,
    filter: MeteringFilter,
    userId: string,
    filterArea: string,
    meteringPoints: MeteringPoint[],
    meteringPointGroups?: MeteringPointGroup[] }) {}
}
export class FilterSettingReset implements Action {
  readonly type = SettingActionTypes.FilterSettingReset;
  constructor(public payload: MeteringType) {}
}
export class SetSubFilter implements Action {
  readonly type = SettingActionTypes.SetSubFilter;
  constructor(public payload: MeteringSubFilter) {}
}

export class SubFilterReset implements Action {
  readonly type = SettingActionTypes.SubFilterReset;
  constructor(public payload: MeteringType) {}
}

export class UserRadioSelection implements Action {
  readonly type = SettingActionTypes.UserRadioSelection;
  constructor(public payload: { meteringType: MeteringType; widget: Widget }) {}
}

export type SettingActions =
  | SettingLoad
  | SettingLoadSuccess
  | SettingLoadFail
  | SettingUpdate
  | FilterSettingUpdate
  | FilterSettingReset
  | SettingUpdateSuccess
  | SettingUpdateFail
  | SetSubFilter
  | SubFilterReset
  | UserRadioSelection;
